import ProductHeroPanel from './ProductHeroPanel';

export default ProductHeroPanel;
